const styles = (theme) => ({
  container: {
    display: "flex",
    flexDirection: "column",
    overflow: "hidden",
    flex: 1,
    backgroundColor: theme.ModalBGColor,
  },
  moduleHeader: {
    color: theme.HeaderSelectedText,
    borderBottom: `1px solid ${theme.AppBGColor}`,
    fontWeight: "bold",
    padding: `10px 32px`,
    fontSize: 14,
  },
  moduleContainer: {
    padding: 32,
    display: "flex",
  },
  formContainer: {
    padding: "20px 20px 0px 20px",
  },
  formLabel: {
    fontWeight: 500,
    fontSize: theme.textFontSize,
    lineHeight: "19px",
    color: theme.iconColor,
    width: "30%",
    paddingRight: "10px",
  },

  formValue: {
    width: "100%",
    display: "flex",
    direction: "column",
    "&>div": {
      flex: 1,
      width: "100%",
    },
  },

  root: {
    padding: "0px 8px 0px 0px;",
  },
  title: {
    color: theme.HeaderSelectedText,
  },
  circularProgress: {
    color: theme.white,
  },
  actionButton: {
    textTransform: "none",
    minWidth: 120,
    "& $actionButtonDisabled": {
      cursor: "not-allowed",
      color: theme.iconColor,
      backgroundColor: theme.headerIconColor,
    },
    "&$actionOutlineDisabled": {
      borderColor: theme.iconColor,
      color: theme.iconColor,
    },
  },
  actionButtonDisabled: {
    backgroundColor: theme.HeaderSelectedText,
  },
  actionOutlineDisabled: {},
  actionContainer: {
    display: "flex",
    justifyContent: "space-around",
    paddingTop: "20px",
  },
  inputRoot: {
    "& $notchedOutline, &:hover:not($inputFocused):not($inputDisabled):not($inputError) $notchedOutline":
      {
        borderColor: `${theme.iconColor}`,
      },
  },
  inputFocused: {},
  inputDisabled: {},
  inputError: {},
  inputField: {
    padding: 12,
    fontSize: theme.textFontSize,
    color: theme.TextColor,
    height: "initial",
  },
  errorMessage: {
    padding: "10px 0px",
    color: theme.palette.error.main,
    fontSize: theme.textFontSize,
  },

  errorMessageVisible: {
    color: theme.palette.error.main,
    fontSize: theme.textFontSize,
    marginTop: "8px",
    paddingLeft: "10px",
    marginBottom: "2px",
  },

  editorContainerTime: {
    marginTop: "8px",
    marginBottom: "8px",
    "&>div": {
      maxWidth: "100%",
      marginTop: 0,
      "&>div": {
        width: "100%",
        "&>div": {
          maxWidth: "100%",
          height: 40,
          borderRadius: 4,
          marginTop : 12
        },
      },
    },
  },
  editorContainerTimeError: {
    marginTop: "8px",
    marginBottom: "8px",
    "&>div": {
      maxWidth: "100%",
      marginTop: 0,
      "&>div": {
        width: "100%",
        "&>div": {
          maxWidth: "100%",
          height: 40,
          borderRadius: 4,
          borderColor: `${theme.ErrorMessageColor}`,
          marginTop : 12
        },
      },
    },
  },
  labelProps: {
    fontSize: theme.headerTextFontSize,
    backgroundColor: theme.ModalBGColor,
    color: theme.iconColor,
    opacity: 0.7,
  },
  filledLabel: {
    top: 4,
    "&$shrink": {
      transform: "translate(8px, 2px) scale(0.75)",
      padding: "0px 4px 0px 4px",
      opacity: 1,
    },
  },
  shrink: {},
  timeEditorInput: {
    background: "transparent",
    "&:hover,&$timeEditorInputFocused": {
      background: "transparent",
    },
  },
  timeEditorInputFocused: {},
  flexRow: {
    display: "flex",
    direction: "column",
    "&>div": {
      flex: 1,
      width: "100%",
    },
  },
});

export default styles;
